export const flashWarning = (message: string, error?: Error) => {
  window.flashNotifier?.('warning', message, 3);
  if (error) {
    window.Monitoring?.addError(error, 'PriceRules', {});
  }
};

export const getEmployeeShopsIDs = (employeeShops: EmployeeFromAPI): number[] => {
  const employeeShopsIDs = employeeShops.Employee?.EmployeeShops?.EmployeeShop || [];
  const employeeShopsIDsArray = [].concat(employeeShopsIDs);
  return employeeShopsIDsArray.reduce((prev: number[], curr) => {
    const { shopID } = curr;
    if (!shopID) {
      return prev;
    }
    return [...prev, parseInt(shopID, 10)];
  }, []);
};

export const getCustomerTypesURL = () =>
  `API/Account/${window.merchantos.session.getSystemCustomerID()}/CustomerType.json`;

export const getCustomerTypesList = (customerTypes: CustomerTypeFromAPI): AutocompleteOption[] => {
  const customerTypesResponse = customerTypes.CustomerType || [];
  const customerTypesArray = ([] as CustomerType[]).concat(customerTypesResponse);
  return customerTypesArray.map(
    ({ name, customerTypeID }: CustomerType): AutocompleteOption => ({
      label: `${name}`,
      value: customerTypeID ? parseInt(customerTypeID, 10) : '',
    })
  );
};

export const postCustomerType = async (customerTypeName: string) => {
  const name = customerTypeName.trim();
  if (!name.length) {
    flashWarning('Customer type name cannot be empty');
    return null;
  }
  try {
    const response = await window.fetch(getCustomerTypesURL(), {
      body: JSON.stringify({
        name,
      }),
      headers: {
        'Content-Type': 'text/json',
      },
      method: 'POST',
    });
    const jsonResponse = await response.json();
    return jsonResponse;
  } catch (error) {
    flashWarning('Customer types creation failed', error);
  }
  return null;
};
